'use client'

import { Link } from '@algoacademy/design-system/web/actions/Link'
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph'
import { useSearchParams } from 'next/navigation'

export function LoginButton() {
  const searchParams = useSearchParams()
  const redirectTo = searchParams.get('redirectTo') ?? searchParams.get('callbackUrl') ?? '/app'

  return (
    <P3 className='text-center'>
      Masz już konto?{' '}
      <Link
        href={`/auth/login?redirectTo=${encodeURIComponent(redirectTo)}`}
        className='font-medium text-contentNavyAlgo hover:underline'
      >
        Zaloguj się
      </Link>
    </P3>
  )
}
